var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center c-pointer justify-content-between",on:{"click":function($event){_vm.onClick ? _vm.onClick(_vm.name) : null}}},[_c('div',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.label))]),_c('div',[_c('div',{class:'background-image w-12px h-12px ms-2 ' + _vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }